import {
    SCHEDULED_MESSAGES_ENDPOINT,
    SCHEDULED_MESSAGE_SCHEDULE_ENDPOINT,
    SCHEDULED_MESSAGE_SEND_NOW_ENDPOINT,
    SCHEDULED_MESSAGE_BY_ID_ENDPOINT,
    SCHEDULED_MESSAGE_CANCEL_ENDPOINT
} from "../api-services/ApiEndpoints";

const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
    };
};

export const getAllScheduledMessages = async () => {
    const url = `${process.env.REACT_APP_API_URL}${SCHEDULED_MESSAGES_ENDPOINT}`;
    
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: getAuthHeaders(),
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to fetch scheduled messages: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Get scheduled messages error:', error);
        throw error;
    }
};

export const getScheduledMessageById = async (id) => {
    const url = `${process.env.REACT_APP_API_URL}${SCHEDULED_MESSAGE_BY_ID_ENDPOINT.replace('{id}', id)}`;
    
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: getAuthHeaders(),
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to fetch scheduled message: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Get scheduled message error:', error);
        throw error;
    }
};

export const scheduleMessage = async (messageData) => {
    const url = `${process.env.REACT_APP_API_URL}${SCHEDULED_MESSAGE_SCHEDULE_ENDPOINT}`;
    
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: getAuthHeaders(),
            body: JSON.stringify(messageData)
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to schedule message: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Schedule message error:', error);
        throw error;
    }
};

export const sendMessageNow = async (messageData) => {
    const url = `${process.env.REACT_APP_API_URL}${SCHEDULED_MESSAGE_SEND_NOW_ENDPOINT}`;
    
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: getAuthHeaders(),
            body: JSON.stringify(messageData)
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to send message: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Send message error:', error);
        throw error;
    }
};

export const cancelScheduledMessage = async (id) => {
    const url = `${process.env.REACT_APP_API_URL}${SCHEDULED_MESSAGE_CANCEL_ENDPOINT.replace('{id}', id)}`;
    
    try {
        const response = await fetch(url, {
            method: 'PATCH',
            headers: getAuthHeaders(),
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to cancel message: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Cancel message error:', error);
        throw error;
    }
};

export const deleteScheduledMessage = async (id) => {
    const url = `${process.env.REACT_APP_API_URL}${SCHEDULED_MESSAGE_BY_ID_ENDPOINT.replace('{id}', id)}`;
    
    try {
        const response = await fetch(url, {
            method: 'DELETE',
            headers: getAuthHeaders(),
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to delete message: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Delete message error:', error);
        throw error;
    }
};
